/**
 * Kanban Board Implementation using jKanban.js
 * Handles project organization by status with drag-and-drop functionality
 * Includes view toggle functionality for switching between table and kanban views
 */

document.addEventListener("DOMContentLoaded", function () {
    // Initialize view toggle if elements exist
    initViewToggle();
    
    // Initialize kanban board
    initKanbanBoard();
    
    // Handle Mark Complete button click from kanban
    initKanbanMarkComplete();
});

/**
 * Handle Mark Complete button click when triggered from kanban or status modal
 * Calls the same updateProjectCompletedField function as the dashboard
 */
function initKanbanMarkComplete() {
    const markCompleteBtn = document.getElementById('markCompleteButton');
    if (!markCompleteBtn) return;
    
    markCompleteBtn.addEventListener('click', async function(e) {
        // Only intercept if triggered from kanban or status modal
        const fromKanban = this.getAttribute('data-from-kanban') === 'true';
        const fromStatusModal = this.getAttribute('data-from-status-modal') === 'true';

        console.log('[Mark Complete] Button clicked, fromKanban:', fromKanban, 'fromStatusModal:', fromStatusModal);

        if (!fromKanban && !fromStatusModal) {
            console.log('[Mark Complete] Not from kanban/status modal, letting normal handler take over');
            return; // Let the normal handler (from web-assessment-dashboard.js) take over
        }

        e.preventDefault();
        e.stopPropagation();

        const projectId = jQuery(this).data('project-id');
        console.log('[Mark Complete] Project ID:', projectId);
        console.log('[Mark Complete] calculatedOverallMaturityScore:', typeof WebAssessmentCharts !== 'undefined' ? WebAssessmentCharts.calculatedOverallMaturityScore : 'N/A');
        console.log('[Mark Complete] frameworkId:', typeof WebAssessmentCharts !== 'undefined' ? WebAssessmentCharts.frameworkId : 'N/A');
        console.log('[Mark Complete] frameworkSlug:', typeof WebAssessmentCharts !== 'undefined' ? WebAssessmentCharts.frameworkSlug : 'N/A');

        if (projectId && typeof updateProjectCompletedField === 'function') {
            // Clear the pending complete project so the card doesn't move back (if from kanban)
            if (fromKanban) {
                window.pendingCompleteProject = null;

                // Mark the card as completed so subsequent drags back into the Complete
                // column skip the Mark Complete modal.
                const card = document.querySelector('.kanban-item[data-eid="' + projectId + '"]');
                if (card) {
                    card.setAttribute('data-is-completed', 'true');
                    card.classList.add('kanban-item-completed');
                }

                // Decide whether to reassign project_status to 'complete'.
                // Drag path: jKanban already moved the card into the Complete column, so its
                // current board is 'complete' — keep the status in sync.
                // Button path (in-card Finalize Data): respect the card's current column.
                // If it has a real custom status term, preserve it. Only promote to 'complete'
                // when the card is sitting in the 'unassigned' column (no status term at all).
                const currentBoard = card && card.closest('.kanban-board');
                const currentBoardId = currentBoard ? currentBoard.getAttribute('data-id') : null;
                const shouldSetStatusComplete = currentBoardId === 'complete' || currentBoardId === 'unassigned';

                if (shouldSetStatusComplete && typeof kanbanData !== 'undefined' && kanbanData.ajax_url) {
                    const statusFormData = new FormData();
                    statusFormData.append('action', 'update_project_kanban_status');
                    statusFormData.append('nonce', kanbanData.nonce);
                    statusFormData.append('userId', kanbanData.user_id);
                    statusFormData.append('postId', projectId);
                    statusFormData.append('newStatus', 'complete');

                    try {
                        await fetch(kanbanData.ajax_url, {
                            method: 'POST',
                            body: statusFormData,
                            credentials: 'same-origin'
                        });
                        console.log('[Mark Complete] project_status set to complete (from board ' + currentBoardId + ')');
                    } catch (err) {
                        console.error('[Mark Complete] Failed to set project_status=complete:', err);
                    }
                } else {
                    console.log('[Mark Complete] Preserving existing project_status (current board: ' + currentBoardId + ')');
                }
            }

            console.log('[Mark Complete] Calling updateProjectCompletedField...');
            // Call the same function as the dashboard
            updateProjectCompletedField(projectId);
        } else {
            console.error('[Mark Complete] updateProjectCompletedField not available:', typeof updateProjectCompletedField);
            console.error('[Mark Complete] projectId:', projectId);
        }
    });
}

/**
 * View Toggle Functionality
 * Switches between table view and kanban view on the assessments page
 * Handles toggle buttons in both views (table and kanban each have their own toggle)
 */
function initViewToggle() {
    const tableViewBtns = document.querySelectorAll('#table-view-btn');
    const kanbanViewBtns = document.querySelectorAll('#kanban-view-btn');
    const tableView = document.getElementById('table-view');
    const kanbanView = document.getElementById('kanban-view');

    // Check if elements exist (only on pages with view toggle)
    if (tableViewBtns.length === 0 || kanbanViewBtns.length === 0 || !tableView || !kanbanView) {
        return;
    }

    // Get saved preference from localStorage
    const savedView = localStorage.getItem('projectsViewPreference') || 'table';

    // Set initial state based on saved preference
    if (savedView === 'kanban') {
        showKanbanView();
    } else {
        showTableView();
    }

    // Table view button click (handle all instances)
    tableViewBtns.forEach(btn => {
        btn.addEventListener('click', function() {
            showTableView();
            localStorage.setItem('projectsViewPreference', 'table');
        });
    });

    // Kanban view button click (handle all instances)
    kanbanViewBtns.forEach(btn => {
        btn.addEventListener('click', function() {
            showKanbanView();
            localStorage.setItem('projectsViewPreference', 'kanban');
        });
    });

    function showTableView() {
        tableView.style.display = 'block';
        kanbanView.style.display = 'none';
        // Update all toggle buttons
        tableViewBtns.forEach(btn => btn.classList.add('active'));
        kanbanViewBtns.forEach(btn => btn.classList.remove('active'));
    }

    function showKanbanView() {
        tableView.style.display = 'none';
        kanbanView.style.display = 'block';
        // Update all toggle buttons
        tableViewBtns.forEach(btn => btn.classList.remove('active'));
        kanbanViewBtns.forEach(btn => btn.classList.add('active'));

        // Initialize kanban if not already initialized
        initKanbanBoard();
    }
}

/**
 * While a kanban card is being dragged, dragula adds a .gu-mirror element.
 * Auto-scroll:
 *  - Horizontally: pointer near the left/right edge of #kanban-board (off-screen columns).
 *  - Vertically: pointer near the top/bottom edge of any scrollable ancestor (tall
 *    columns, card body, or the main page) so you can reach other columns after
 *    scrolling down a long list.
 * The top scrollbar (see initTopScrollbar) stays in sync via the scroll event on #kanban-board.
 */
function initKanbanDragAutoScroll() {
    const scroller = document.getElementById('kanban-board');
    if (!scroller) {
        return;
    }

    const EDGE_PX = 80;
    const MAX_STEP = 32; // horizontal (matches prior feel)
    // Vertical: higher cap + steeper ramp; main window scroll is applied first when
    // the pointer is in the top/bottom *viewport* band so we don’t crawl a small
    // inner overflow container one frame at a time.
    const MAX_STEP_V = 180;
    const V_STEP_BASE = 36;
    const V_STEP_RAMP = 144; // t=1 at inner edge of band => cap
    const V_TICK_PASSES = 2; // apply vertical scroll this many times per rAF

    let lastX = 0;
    let lastY = 0;
    let rafId = null;

    function isActiveItemDrag() {
        return document.querySelector('.gu-mirror') !== null;
    }

    function getClientX(e) {
        if (e.touches && e.touches.length) {
            return e.touches[0].clientX;
        }
        return e.clientX;
    }

    function getClientY(e) {
        if (e.touches && e.touches.length) {
            return e.touches[0].clientY;
        }
        return e.clientY;
    }

    /**
     * Scrollable ancestors of #kanban-board, innermost-first, plus the document
     * scroller when the page itself can scroll.
     *
     * When the pointer is in the top/bottom band of the *viewport* (typical when
     * auto-scrolling the page), put document.scrollingElement first. Otherwise a
     * small overflow-y wrapper can "win" every frame and page scroll feels glacial.
     */
    function getVerticalScrollTargets() {
        const fromParents = [];
        let node = scroller;

        while (node && node !== document.body) {
            if (node.parentElement) {
                node = node.parentElement;
            } else {
                break;
            }
            const st = window.getComputedStyle(node);
            const oy = st.overflowY;
            if ((oy === 'auto' || oy === 'scroll' || oy === 'overlay') && node.scrollHeight > node.clientHeight + 1) {
                fromParents.push(node);
            }
        }

        const root = document.scrollingElement;
        const rootOk = root && root.scrollHeight > root.clientHeight + 1;

        const inViewportVerticalBand = lastY <= EDGE_PX || lastY >= window.innerHeight - EDGE_PX;

        if (inViewportVerticalBand && rootOk) {
            const rest = fromParents.filter(function (el) {
                return el !== root && el !== document.documentElement && el !== document.body;
            });
            return [root].concat(rest);
        }

        if (rootOk && fromParents.indexOf(root) === -1) {
            fromParents.push(root);
        }

        return fromParents;
    }

    function getVisibleRectForScrollElement(el) {
        if (el === document.documentElement || el === document.scrollingElement) {
            return {
                top: 0,
                left: 0,
                right: window.innerWidth,
                bottom: window.innerHeight
            };
        }
        return el.getBoundingClientRect();
    }

    function applyVerticalAutoScroll() {
        for (let pass = 0; pass < V_TICK_PASSES; pass++) {
            const targets = getVerticalScrollTargets();
            let moved = false;
            for (let i = 0; i < targets.length; i++) {
                const el = targets[i];
                const rect = getVisibleRectForScrollElement(el);
                const maxY = el.scrollHeight - el.clientHeight;
                if (maxY <= 0) {
                    continue;
                }

                if (lastY <= rect.top + EDGE_PX && el.scrollTop > 0) {
                    const t = (rect.top + EDGE_PX - lastY) / EDGE_PX;
                    const step = Math.min(MAX_STEP_V, V_STEP_BASE + t * V_STEP_RAMP);
                    el.scrollTop = Math.max(0, el.scrollTop - step);
                    moved = true;
                    break;
                }
                if (lastY >= rect.bottom - EDGE_PX && el.scrollTop < maxY - 0.5) {
                    const t = (lastY - (rect.bottom - EDGE_PX)) / EDGE_PX;
                    const step = Math.min(MAX_STEP_V, V_STEP_BASE + t * V_STEP_RAMP);
                    el.scrollTop = Math.min(maxY, el.scrollTop + step);
                    moved = true;
                    break;
                }
            }
            if (!moved) {
                break;
            }
        }
    }

    function shouldContinueAutoScroll() {
        if (!isActiveItemDrag()) {
            return false;
        }

        const hRect = scroller.getBoundingClientRect();
        const maxH = scroller.scrollWidth - scroller.clientWidth;
        if (maxH > 0) {
            if (lastX >= hRect.right - EDGE_PX && scroller.scrollLeft < maxH - 0.5) {
                return true;
            }
            if (lastX <= hRect.left + EDGE_PX && scroller.scrollLeft > 0) {
                return true;
            }
        }

        const vTargets = getVerticalScrollTargets();
        for (let i = 0; i < vTargets.length; i++) {
            const el = vTargets[i];
            const rect = getVisibleRectForScrollElement(el);
            const maxY = el.scrollHeight - el.clientHeight;
            if (maxY <= 0) {
                continue;
            }
            if (lastY <= rect.top + EDGE_PX && el.scrollTop > 0) {
                return true;
            }
            if (lastY >= rect.bottom - EDGE_PX && el.scrollTop < maxY - 0.5) {
                return true;
            }
        }

        return false;
    }

    function tick() {
        rafId = null;
        if (!isActiveItemDrag()) {
            return;
        }

        const hRect = scroller.getBoundingClientRect();
        const maxH = scroller.scrollWidth - scroller.clientWidth;
        if (maxH > 0) {
            let stepH = 0;
            if (lastX >= hRect.right - EDGE_PX) {
                const t = (lastX - (hRect.right - EDGE_PX)) / EDGE_PX;
                stepH = Math.min(MAX_STEP, 6 + t * 26);
            } else if (lastX <= hRect.left + EDGE_PX) {
                const t = ((hRect.left + EDGE_PX) - lastX) / EDGE_PX;
                stepH = -Math.min(MAX_STEP, 6 + t * 26);
            }
            if (stepH !== 0) {
                scroller.scrollLeft = Math.max(0, Math.min(maxH, scroller.scrollLeft + stepH));
            }
        }

        applyVerticalAutoScroll();

        if (shouldContinueAutoScroll()) {
            rafId = requestAnimationFrame(tick);
        }
    }

    function onPointerMove(e) {
        lastX = getClientX(e);
        lastY = getClientY(e);
        if (!isActiveItemDrag()) {
            return;
        }
        if (rafId === null) {
            rafId = requestAnimationFrame(tick);
        }
    }

    document.addEventListener('mousemove', onPointerMove, { passive: true });
    document.addEventListener('touchmove', onPointerMove, { passive: true });
}

function initKanbanBoard() {
    // Don't initialize if already done
    if (window.kanbanInstance) {
        return;
    }

    // Check if kanban board element exists
    const kanbanElement = document.getElementById('kanban-board');
    if (!kanbanElement) {
        return;
    }

    // Check if kanban view is visible (for embedded kanban)
    const kanbanView = document.getElementById('kanban-view');
    if (kanbanView && kanbanView.style.display === 'none') {
        return;
    }

    // Get board data from PHP (embedded in page)
    const kanbanBoardsData = window.kanbanBoardsData || [];
    
    if (kanbanBoardsData.length === 0) {
        console.warn('No kanban board data available');
        return;
    }

    function calculateNYCRRScore() {
        return new Promise((resolve) => {
            const processedItems = WebAssessmentCharts.processedItems;
            const categoryScores = {};

            processedItems.forEach(item => {
                const safeguardId = item.safeguardid.S;
                const match = safeguardId.match(/^500\.(\d+)/);

                if (match) {
                    const category = match[1];
                    const maturityScore = item.maturityscore;

                    if (maturityScore !== null) {
                        if (!categoryScores[category]) {
                            categoryScores[category] = { total: 0, count: 0 };
                        }
                        categoryScores[category].total += maturityScore;
                        categoryScores[category].count++;
                    }
                }
            });

            const categoryAverages = [];
            Object.keys(categoryScores).forEach(category => {
                const { total, count } = categoryScores[category];
                if (count > 0) {
                    categoryAverages.push((total / count) * 5);
                }
            });

            if (categoryAverages.length > 0) {
                const sumOfAverages = categoryAverages.reduce((acc, val) => acc + val, 0);
                resolve(sumOfAverages / categoryAverages.length);
            } else {
                resolve(0);
            }
        });
    }

    function calculateCRFSScore(slug) {
        return new Promise((resolve) => {
            WebAssessmentCharts.crfMaturityLevelScoresDispatcher(slug);

            let scoresObject;
            if (slug === 'crf-s-2021') {
                scoresObject = WebAssessmentCharts.MaturityScoresOverall2021;
            } else if (slug === 'crf-s-2022') {
                scoresObject = WebAssessmentCharts.MaturityScoresOverall2022;
            } else if (slug === 'crf-s-2023') {
                scoresObject = WebAssessmentCharts.MaturityScoresOverall2023;
            } else if (slug === 'crf-s' || slug === 'crf-s-2024') {
                scoresObject = WebAssessmentCharts.MaturityScoresOverall2024;
            } else if (slug === 'crf-s-2025') {
                scoresObject = WebAssessmentCharts.MaturityScoresOverall2025;
            } else if (slug === 'crf-s-2026' || slug === 'crf-s-appsec-2026' || slug === 'crf-s-gov-2026' || slug === 'crf-s-hyg-2026' || slug === 'crf-s-smb-2026') {
                scoresObject = WebAssessmentCharts.MaturityScoresOverall2026;
            }

            if (scoresObject && typeof scoresObject === 'object') {
                const scoreValues = Object.values(scoresObject).filter(v => typeof v === 'number' && !isNaN(v));
                if (scoreValues.length > 0) {
                    const sum = scoreValues.reduce((acc, val) => acc + val, 0);
                    resolve(sum / scoreValues.length);
                } else {
                    resolve(0);
                }
            } else {
                resolve(0);
            }
        });
    }

    // Shared entry point for the Finalize Data flow used by both the drag-to-complete drop
    // and the in-card Finalize Data button. sourceBoard is the pre-drop column (passed only
    // from drag path) so we can snap the card back if the user cancels; the button path
    // passes null because nothing moved.
    function openKanbanCompletionModal(el, sourceBoard) {
        const projectPostId = el.getAttribute('data-eid');
        const projectSlug = el.getAttribute('data-project-slug');
        const frameworkId = el.getAttribute('data-framework-id');
        const frameworkSlug = el.getAttribute('data-framework-slug');

        window.pendingCompleteProject = {
            element: el,
            postId: projectPostId,
            slug: projectSlug,
            sourceBoard: sourceBoard,
            targetBoard: null
        };

        const modal = document.getElementById('completeConfirmModal');
        if (!modal) {
            return;
        }

        const modalButtons = modal.querySelector('.mark-complete-modal-buttons');
        const markCompleteBtn = modal.querySelector('#markCompleteButton');
        const spinner = modal.querySelector('.spinner-border');

        if (modalButtons) modalButtons.style.display = 'none';
        if (markCompleteBtn) markCompleteBtn.style.display = 'none';
        if (spinner) spinner.style.display = 'block';

        if (markCompleteBtn) {
            jQuery(markCompleteBtn).data('project-id', projectPostId);
            markCompleteBtn.setAttribute('data-project-id', projectPostId);
            markCompleteBtn.setAttribute('data-from-kanban', 'true');
        }

        const bsModal = new bootstrap.Modal(modal);
        bsModal.show();

        if (typeof WebAssessmentCharts !== 'undefined' && frameworkSlug) {
            WebAssessmentCharts.frameworkId = frameworkId;
            WebAssessmentCharts.frameworkSlug = frameworkSlug;
            WebAssessmentCharts.calculatedOverallMaturityScore = null;

            new Promise((resolve, reject) => {
                try {
                    WebAssessmentCharts.fetchDataAndCalculateScoresDispatcher(projectSlug, frameworkSlug)
                        .then(() => resolve())
                        .catch(error => reject(error));
                } catch (error) {
                    reject(error);
                }
            })
            .then(() => {
                let calculationPromise;

                if (frameworkSlug.startsWith('cis-')) {
                    calculationPromise = WebAssessmentCharts.calculateCISAverages(WebAssessmentCharts.processedItems);
                } else if (frameworkSlug.startsWith('nist-csf-')) {
                    calculationPromise = WebAssessmentCharts.calculateNIST2Averages(WebAssessmentCharts.processedItems);
                } else if (frameworkSlug.startsWith('nycrr-')) {
                    calculationPromise = calculateNYCRRScore();
                } else if (frameworkSlug.startsWith('crf-s')) {
                    calculationPromise = calculateCRFSScore(frameworkSlug);
                } else {
                    calculationPromise = Promise.resolve();
                }

                return calculationPromise.then(score => {
                    if (score && typeof score === 'object' && score.hasOwnProperty('overallMaturity')) {
                        WebAssessmentCharts.calculatedOverallMaturityScore = score.overallMaturity;
                    } else if (typeof score === 'number') {
                        WebAssessmentCharts.calculatedOverallMaturityScore = score;
                    }
                });
            })
            .then(() => {
                if (modalButtons) modalButtons.style.display = 'block';
                if (markCompleteBtn) markCompleteBtn.style.display = 'inline-block';
                if (spinner) spinner.style.display = 'none';
            })
            .catch(error => {
                console.error('Error calculating scores:', error);
                if (modalButtons) modalButtons.style.display = 'block';
                if (markCompleteBtn) markCompleteBtn.style.display = 'inline-block';
                if (spinner) spinner.style.display = 'none';
            });
        } else {
            if (modalButtons) modalButtons.style.display = 'block';
            if (markCompleteBtn) markCompleteBtn.style.display = 'inline-block';
            if (spinner) spinner.style.display = 'none';
        }

        modal.addEventListener('hidden.bs.modal', function handler() {
            if (window.pendingCompleteProject) {
                // Only snap the card back if it actually moved (drag path).
                const pending = window.pendingCompleteProject;
                if (pending.sourceBoard && pending.element) {
                    pending.sourceBoard.appendChild(pending.element);
                }
                window.pendingCompleteProject = null;
            }

            if (markCompleteBtn) {
                markCompleteBtn.removeAttribute('data-from-kanban');
            }

            modal.removeEventListener('hidden.bs.modal', handler);
        });
    }

    // In-card Finalize Data button (rendered by build_kanban_item_html when percent=100 and not yet finalized).
    // Must run in the capture phase: jKanban attaches its own click listener directly to each .kanban-item,
    // so a bubble-phase delegated handler fires after window.location.href has already been set.
    document.addEventListener('click', function (e) {
        const btn = e.target.closest && e.target.closest('.btn-finalize-data-kanban');
        if (!btn) {
            return;
        }
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        const item = btn.closest('.kanban-item');
        if (!item) {
            return;
        }
        openKanbanCompletionModal(item, null);
    }, true);

    // Initialize jKanban
    const kanban = new jKanban({
        element: '#kanban-board',
        gutter: '10px',
        widthBoard: '300px',
        dragItems: true,
        dragBoards: false, // Temporarily disabled until multi-org support is implemented
        boards: kanbanBoardsData,
        
        // When an item is dropped
        dropEl: function (el, target, source, sibling) {
            const projectPostId = el.getAttribute('data-eid');
            const newBoardId = target.parentNode.getAttribute('data-id');
            const oldBoardId = source.parentNode.getAttribute('data-id');
            
            // Don't do anything if dropped in same column
            if (newBoardId === oldBoardId) {
                return;
            }
            
            // Enforce per-project move permission: only owners/admins may move cards.
            // If the card is flagged as unmovable, snap it back to its source column
            // and notify the user. The server also rejects unauthorized updates.
            if (el.getAttribute('data-can-move') === 'false') {
                source.appendChild(el);
                showNotification('Only project owners and admins can move this project', 'error');
                return;
            }

            const isAlreadyCompleted = el.getAttribute('data-is-completed') === 'true';

            // If dropping into "complete" column, show confirmation modal and calculate scores.
            // Skip the Mark Complete flow entirely if the project has already been marked
            // complete previously (it may have been moved out and is now being moved back).
            if (newBoardId === 'complete' && !isAlreadyCompleted) {
                openKanbanCompletionModal(el, source);
                return;
            }

            // Update project status via AJAX
            updateProjectStatus(projectPostId, newBoardId, el);

            // Update item color to match new board
            updateItemColor(el, newBoardId);

            // Update status badge in the projects table if the function is available
            if (typeof window.updateStatusBadgeInTable === 'function') {
                window.updateStatusBadgeInTable(projectPostId, newBoardId);
            }
        },
        
        // When a board (column) is dropped
        dropBoard: function (el, target, source, sibling) {
            // Save the new column order
            saveColumnOrder();
        },
        
        // Item click handler - navigate to project
        click: function (el) {
            const projectSlug = el.getAttribute('data-project-slug');
            if (projectSlug) {
                window.location.href = '/projects/' + projectSlug;
            }
        }
    });

    // Store kanban instance globally for adding boards
    window.kanbanInstance = kanban;

    // Apply color classes after initialization (jKanban doesn't support multiple classes)
    applyBoardColors();
    
    // Apply data attributes to items for complete functionality
    applyItemDataAttributes();
    
    // Initialize top scrollbar for easier horizontal scrolling
    initTopScrollbar();

    // Auto-scroll horizontally when dragging a card against the left/right edge
    initKanbanDragAutoScroll();

    /**
     * Apply color classes to boards and items based on board data
     */
    function applyBoardColors() {
        kanbanBoardsData.forEach(boardData => {
            if (boardData.color) {
                const board = document.querySelector('.kanban-board[data-id="' + boardData.id + '"]');
                if (board) {
                    board.classList.add('kanban-column-color-' + boardData.color);
                    
                    // Also apply to items
                    const items = board.querySelectorAll('.kanban-item');
                    items.forEach(item => {
                        item.classList.add('kanban-item-color-' + boardData.color);
                    });
                }
            }
        });
    }
    
    /**
     * Apply data attributes to kanban items for complete functionality
     */
    function applyItemDataAttributes() {
        kanbanBoardsData.forEach(boardData => {
            if (boardData.item) {
                boardData.item.forEach(itemData => {
                    const item = document.querySelector('.kanban-item[data-eid="' + itemData.id + '"]');
                    if (item) {
                        item.setAttribute('data-framework-id', itemData['framework-id'] || '');
                        item.setAttribute('data-framework-slug', itemData['framework-slug'] || '');

                        // Mark completed items
                        if (itemData['is-completed']) {
                            item.setAttribute('data-is-completed', 'true');
                            item.classList.add('kanban-item-completed');
                        }

                        // Flag cards the current user is not allowed to move (only project
                        // owners/admins can change status). dropEl enforces this as well,
                        // but we also disable the drag handle so users without permission
                        // can't initiate the drag in the first place.
                        if (itemData['can-move'] === false) {
                            item.setAttribute('data-can-move', 'false');
                            item.classList.add('kanban-item-locked');
                            item.setAttribute('draggable', 'false');
                        }
                    }
                });
            }
        });
    }

    /**
     * Initialize top scrollbar that syncs with the kanban board's horizontal scroll
     */
    function initTopScrollbar() {
        const kanbanBoard = document.getElementById('kanban-board');
        if (!kanbanBoard) return;
        
        // Create top scrollbar container
        const topScrollbar = document.createElement('div');
        topScrollbar.className = 'kanban-top-scrollbar';
        
        // Create inner div that will have the same width as the kanban content
        const innerDiv = document.createElement('div');
        innerDiv.className = 'kanban-top-scrollbar-inner';
        topScrollbar.appendChild(innerDiv);
        
        // Insert before kanban board
        kanbanBoard.parentNode.insertBefore(topScrollbar, kanbanBoard);
        
        // Function to update the inner width to match kanban content
        function updateScrollbarWidth() {
            const kanbanContainer = kanbanBoard.querySelector('.kanban-container');
            if (kanbanContainer) {
                innerDiv.style.width = kanbanContainer.scrollWidth + 'px';
            } else {
                innerDiv.style.width = kanbanBoard.scrollWidth + 'px';
            }
        }
        
        // Initial width update
        updateScrollbarWidth();
        
        // Sync scrolling between top scrollbar and kanban board
        let isSyncing = false;
        
        topScrollbar.addEventListener('scroll', function() {
            if (!isSyncing) {
                isSyncing = true;
                kanbanBoard.scrollLeft = topScrollbar.scrollLeft;
                isSyncing = false;
            }
        });
        
        kanbanBoard.addEventListener('scroll', function() {
            if (!isSyncing) {
                isSyncing = true;
                topScrollbar.scrollLeft = kanbanBoard.scrollLeft;
                isSyncing = false;
            }
        });
        
        // Update width when window is resized
        window.addEventListener('resize', updateScrollbarWidth);
        
        // Also update after a short delay to catch any dynamic content changes
        setTimeout(updateScrollbarWidth, 500);
    }

    /**
     * Update item color to match its board
     */
    function updateItemColor(itemElement, boardId) {
        // Find the board data
        const boardData = kanbanBoardsData.find(board => board.id === boardId);
        if (!boardData || !boardData.color) {
            return;
        }

        // Remove all existing color classes
        const colorClasses = ['gray', 'brown', 'orange', 'yellow', 'green', 'blue', 'purple', 'pink', 'red'];
        colorClasses.forEach(color => {
            itemElement.classList.remove('kanban-item-color-' + color);
        });

        // Add the new color class
        itemElement.classList.add('kanban-item-color-' + boardData.color);
    }

    /**
     * Update project status via AJAX
     */
    function updateProjectStatus(postId, newStatus, element) {
        const formData = new FormData();
        formData.append('action', 'update_project_kanban_status');
        formData.append('nonce', kanbanData.nonce);
        formData.append('userId', kanbanData.user_id);
        formData.append('postId', postId);
        formData.append('newStatus', newStatus);

        fetch(kanbanData.ajax_url, {
            method: 'POST',
            body: formData,
            credentials: 'same-origin'
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                showNotification('Project status updated', 'success');
            } else {
                showNotification(data.data || 'Failed to update project status', 'error');
                console.error('Failed to update project status:', data.data);
            }
        })
        .catch(error => {
            showNotification('An error occurred while updating project status', 'error');
            console.error('Error updating project status:', error);
        });
    }

    /**
     * Save column order via AJAX
     */
    function saveColumnOrder() {
        const boards = document.querySelectorAll('#kanban-board .kanban-board');
        const columnOrder = [];
        
        boards.forEach(board => {
            const boardId = board.getAttribute('data-id');
            if (boardId) {
                columnOrder.push(boardId);
            }
        });

        const formData = new FormData();
        formData.append('action', 'save_kanban_column_order');
        formData.append('nonce', kanbanData.nonce);
        formData.append('userId', kanbanData.user_id);
        
        columnOrder.forEach((slug, index) => {
            formData.append('columnOrder[' + index + ']', slug);
        });

        fetch(kanbanData.ajax_url, {
            method: 'POST',
            body: formData,
            credentials: 'same-origin'
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                showNotification('Column order saved', 'success');
            } else {
                showNotification(data.data || 'Failed to save column order', 'error');
            }
        })
        .catch(error => {
            showNotification('An error occurred while saving column order', 'error');
            console.error('Error saving column order:', error);
        });
    }

    /**
     * Show notification message
     */
    function showNotification(message, type) {
        const notification = document.createElement('div');
        notification.className = 'kanban-notification kanban-notification-' + type;
        notification.textContent = message;
        
        document.body.appendChild(notification);
        
        setTimeout(() => {
            notification.classList.add('show');
        }, 10);
        
        setTimeout(() => {
            notification.classList.remove('show');
            setTimeout(() => {
                notification.remove();
            }, 300);
        }, 3000);
    }

    /**
     * Build column header HTML with dropdown menu
     */
    function buildColumnHeaderHtml(name, slug, color = '') {
        const colorOptions = [
            { value: '', label: 'Default' },
            { value: 'gray', label: 'Gray' },
            { value: 'brown', label: 'Brown' },
            { value: 'orange', label: 'Orange' },
            { value: 'yellow', label: 'Yellow' },
            { value: 'green', label: 'Green' },
            { value: 'blue', label: 'Blue' },
            { value: 'purple', label: 'Purple' },
            { value: 'pink', label: 'Pink' },
            { value: 'red', label: 'Red' }
        ];
        
        let html = '<span class="kanban-column-title"><i class="fas fa-grip-vertical kanban-drag-handle"></i>' + name + '</span>';
        html += '<div class="kanban-column-menu dropdown">';
        html += '<button class="kanban-menu-btn" type="button" data-bs-toggle="dropdown" aria-expanded="false">';
        html += '<i class="fas fa-ellipsis-h"></i>';
        html += '</button>';
        html += '<ul class="dropdown-menu dropdown-menu-end">';
        
        // Delete option
        html += '<li><a class="dropdown-item kanban-delete-column" href="#" data-term-slug="' + slug + '" data-term-name="' + name + '">';
        html += '<i class="fas fa-trash me-2"></i>Delete column</a></li>';
        html += '<li><hr class="dropdown-divider"></li>';
        
        // Color options
        html += '<li class="dropdown-header">Colors</li>';
        colorOptions.forEach(opt => {
            const isSelected = (color === opt.value) ? ' selected' : '';
            const colorClass = opt.value ? 'kanban-color-' + opt.value : 'kanban-color-default';
            html += '<li><a class="dropdown-item kanban-color-option' + isSelected + '" href="#" ';
            html += 'data-term-slug="' + slug + '" data-color="' + opt.value + '">';
            html += '<span class="color-swatch ' + colorClass + '"></span>' + opt.label;
            if (color === opt.value) {
                html += ' <i class="fas fa-check ms-auto"></i>';
            }
            html += '</a></li>';
        });
        
        html += '</ul>';
        html += '</div>';
        
        return html;
    }

    /**
     * Add new column handler
     */
    const addColumnModal = document.getElementById('addColumnModal');
    const addColumnForm = document.getElementById('add-column-form');
    const columnNameInput = document.getElementById('column-name-input');

    if (addColumnForm) {
        addColumnForm.addEventListener('submit', function(e) {
            e.preventDefault();
            const columnName = columnNameInput.value.trim();
            
            if (!columnName) {
                showNotification('Please enter a column name', 'error');
                return;
            }

            createNewColumn(columnName);
        });
    }

    /**
     * Create new column via AJAX
     */
    function createNewColumn(columnName) {
        const formData = new FormData();
        formData.append('action', 'create_project_status_column');
        formData.append('nonce', kanbanData.nonce);
        formData.append('userId', kanbanData.user_id);
        formData.append('columnName', columnName);

        fetch(kanbanData.ajax_url, {
            method: 'POST',
            body: formData,
            credentials: 'same-origin'
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                // Add the new board with dropdown menu
                kanban.addBoards([{
                    id: data.data.slug,
                    title: buildColumnHeaderHtml(data.data.name, data.data.slug, ''),
                    class: 'kanban-status-column',
                    item: []
                }]);
                
                // Clear the input and close modal
                if (columnNameInput) {
                    columnNameInput.value = '';
                }
                
                if (addColumnModal) {
                    const modalInstance = bootstrap.Modal.getInstance(addColumnModal);
                    if (modalInstance) {
                        modalInstance.hide();
                    }
                }
                
                // Rebind handlers for new column
                bindColumnMenuHandlers();
                
                showNotification('Column created successfully', 'success');
            } else {
                showNotification(data.data || 'Failed to create column', 'error');
            }
        })
        .catch(error => {
            showNotification('An error occurred while creating column', 'error');
            console.error('Error creating column:', error);
        });
    }

    /**
     * Bind column menu handlers (delete and color options)
     */
    function bindColumnMenuHandlers() {
        // Delete column handlers
        document.querySelectorAll('.kanban-delete-column').forEach(btn => {
            // Remove existing listeners
            const newBtn = btn.cloneNode(true);
            btn.parentNode.replaceChild(newBtn, btn);
        });
        
        document.querySelectorAll('.kanban-delete-column').forEach(btn => {
            btn.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                const termSlug = this.getAttribute('data-term-slug');
                const termName = this.getAttribute('data-term-name');
                
                // Prevent deleting the Unassigned column
                if (termSlug === 'unassigned') {
                    showNotification('The Unassigned column cannot be deleted', 'error');
                    return;
                }
                
                // Count items in the column
                const board = document.querySelector('.kanban-board[data-id="' + termSlug + '"]');
                const itemCount = board ? board.querySelectorAll('.kanban-item').length : 0;
                
                let confirmMessage = 'Delete "' + termName + '" column?';
                if (itemCount > 0) {
                    confirmMessage += ' ' + itemCount + ' project(s) will be moved to Unassigned.';
                }
                
                if (confirm(confirmMessage)) {
                    deleteColumn(termSlug);
                }
            });
        });

        // Color option handlers
        document.querySelectorAll('.kanban-color-option').forEach(btn => {
            const newBtn = btn.cloneNode(true);
            btn.parentNode.replaceChild(newBtn, btn);
        });
        
        document.querySelectorAll('.kanban-color-option').forEach(btn => {
            btn.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                const termSlug = this.getAttribute('data-term-slug');
                const color = this.getAttribute('data-color');
                
                setColumnColor(termSlug, color, this);
            });
        });
    }

    /**
     * Delete column via AJAX
     * Moves all items to Unassigned first, then removes the column
     */
    function deleteColumn(termSlug) {
        // Get all items from the column being deleted
        const board = document.querySelector('.kanban-board[data-id="' + termSlug + '"]');
        const items = board ? board.querySelectorAll('.kanban-item') : [];
        
        // Create array of promises to update each item's status
        const updatePromises = [];
        
        items.forEach(item => {
            const postId = item.getAttribute('data-eid');
            if (postId) {
                const formData = new FormData();
                formData.append('action', 'update_project_kanban_status');
                formData.append('nonce', kanbanData.nonce);
                formData.append('userId', kanbanData.user_id);
                formData.append('postId', postId);
                formData.append('newStatus', 'unassigned');
                
                updatePromises.push(
                    fetch(kanbanData.ajax_url, {
                        method: 'POST',
                        body: formData,
                        credentials: 'same-origin'
                    }).then(response => response.json())
                );
            }
        });
        
        // Wait for all status updates, then remove the column
        Promise.all(updatePromises)
            .then(results => {
                // Move items visually to Unassigned column
                const unassignedBoard = document.querySelector('.kanban-board[data-id="unassigned"] .kanban-drag');
                if (unassignedBoard) {
                    items.forEach(item => {
                        // Remove color class from items being moved
                        const colorClasses = ['gray', 'brown', 'orange', 'yellow', 'green', 'blue', 'purple', 'pink', 'red'];
                        colorClasses.forEach(c => {
                            item.classList.remove('kanban-item-color-' + c);
                        });
                        unassignedBoard.appendChild(item);
                    });
                }
                
                // Now remove the column from user's board
                const formData = new FormData();
                formData.append('action', 'remove_column_from_board');
                formData.append('nonce', kanbanData.nonce);
                formData.append('userId', kanbanData.user_id);
                formData.append('columnSlug', termSlug);

                return fetch(kanbanData.ajax_url, {
                    method: 'POST',
                    body: formData,
                    credentials: 'same-origin'
                });
            })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    kanban.removeBoard(termSlug);
                    showNotification('Column deleted', 'success');
                } else {
                    showNotification(data.data || 'Failed to delete column', 'error');
                }
            })
            .catch(error => {
                showNotification('An error occurred while deleting column', 'error');
                console.error('Error deleting column:', error);
            });
    }

    /**
     * Set column color via AJAX
     */
    function setColumnColor(termSlug, color, clickedElement) {
        const formData = new FormData();
        formData.append('action', 'save_kanban_column_color');
        formData.append('nonce', kanbanData.nonce);
        formData.append('userId', kanbanData.user_id);
        formData.append('columnSlug', termSlug);
        formData.append('color', color);

        fetch(kanbanData.ajax_url, {
            method: 'POST',
            body: formData,
            credentials: 'same-origin'
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                // Update visual appearance
                updateColumnColorVisual(termSlug, color);
                
                // Update dropdown checkmarks
                const dropdown = clickedElement.closest('.dropdown-menu');
                if (dropdown) {
                    dropdown.querySelectorAll('.kanban-color-option').forEach(opt => {
                        opt.classList.remove('selected');
                        const checkIcon = opt.querySelector('.fa-check');
                        if (checkIcon) checkIcon.remove();
                    });
                    clickedElement.classList.add('selected');
                    clickedElement.insertAdjacentHTML('beforeend', ' <i class="fas fa-check ms-auto"></i>');
                }
                
                showNotification('Column color updated', 'success');
            } else {
                showNotification(data.data || 'Failed to update color', 'error');
            }
        })
        .catch(error => {
            showNotification('An error occurred while updating color', 'error');
            console.error('Error updating color:', error);
        });
    }

    /**
     * Update column and item colors visually
     */
    function updateColumnColorVisual(termSlug, color) {
        const board = document.querySelector('.kanban-board[data-id="' + termSlug + '"]');
        if (!board) return;

        // Remove all existing color classes from board
        const colorClasses = ['gray', 'brown', 'orange', 'yellow', 'green', 'blue', 'purple', 'pink', 'red'];
        colorClasses.forEach(c => {
            board.classList.remove('kanban-column-color-' + c);
        });

        // Add new color class if specified
        if (color) {
            board.classList.add('kanban-column-color-' + color);
        }

        // Update item colors
        const items = board.querySelectorAll('.kanban-item');
        items.forEach(item => {
            colorClasses.forEach(c => {
                item.classList.remove('kanban-item-color-' + c);
            });
            if (color) {
                item.classList.add('kanban-item-color-' + color);
            }
        });
    }

    // Bind handlers on initial load
    bindColumnMenuHandlers();
}
